import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../icons.jsx';
import { LizziLogo } from '../components.jsx';
import { supabase } from '../integrations/supabase/client';

const { useState } = React;

// ==========================================
// Login screen — autenticación real (sin registro público)
// El alta de usuarios la realizan los administradores internamente.
// ==========================================
function LoginScreen() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [demoLoading, setDemoLoading] = useState(false);
  const [error, setError] = useState('');
  const [forgot, setForgot] = useState(false);

  const enterDemo = () => {
    setDemoLoading(true);
    setTimeout(() => navigate('/demo'), 500);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email || !password) { setError('Introduce tu correo y contraseña.'); return; }
    setLoading(true);
    const { error: signErr } = await supabase.auth.signInWithPassword({ email, password });
    if (signErr) {
      setLoading(false);
      setError(
        signErr.message === 'Invalid login credentials'
          ? 'Credenciales incorrectas. Revisa tu correo y contraseña.'
          : signErr.message
      );
      return;
    }
    // ¿MFA pendiente?
    const { data: aal } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
    setLoading(false);
    if (aal && aal.nextLevel === 'aal2' && aal.currentLevel === 'aal1') {
      navigate('/mfa');
    } else {
      navigate('/');
    }
  };

  return (
    <div className="login-split">
      {/* Decorative pane */}
      <div className="login-hero">

        <div className="glow-orb" style={{ width:520, height:520, background:'var(--primary)', top:-160, right:-120, opacity:0.30 }}></div>
        <div className="glow-orb" style={{ width:400, height:400, background:'var(--lime)', bottom:-120, left:-120, opacity:0.20 }}></div>

        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', zIndex:2, position:'relative'}}>
          <LizziLogo size={32}/>
          <div style={{display:'flex', alignItems:'center', gap:10, fontSize:11.5, color:'var(--text-3)', letterSpacing:'0.06em'}}>
            <span style={{width:6, height:6, borderRadius:999, background:'var(--sem-success)'}}></span>
            <span>SISTEMA OPERATIVO · v3.0</span>
          </div>
        </div>

        <div style={{zIndex:2, position:'relative', maxWidth:580}}>
          <div className="page-eyebrow" style={{marginBottom:24}}>El sistema operativo de las licitaciones públicas</div>
          <h1 className="font-display-heavy" style={{fontSize:'clamp(38px, 5.4vw, 84px)', lineHeight:0.96, letterSpacing:'-0.045em', margin:'0 0 24px 0', color:'var(--text-1)'}}>
            Lee pliegos.<br/>
            Calcula costes.<br/>
            <span style={{
              background: 'linear-gradient(120deg, var(--primary), var(--lime))',
              WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent',
              backgroundClip:'text',
            }}>Gana licitaciones.</span>
          </h1>
          <p style={{color:'var(--text-2)', fontSize:17, lineHeight:1.55, maxWidth:520, margin:0}}>
            La capa única que orquesta los doce asistentes especializados de Impact Hub.
            Una herramienta, todo el workflow.
          </p>

          <div style={{display:'flex', gap:'clamp(20px,3vw,48px)', marginTop:'clamp(24px,3vw,48px)', flexWrap:'wrap'}}>
            {[
              { k:'12', l:'asistentes\nespecializados' },
              { k:'85%', l:'del workflow\nautomatizado' },
              { k:'1', l:'sola\nherramienta' },
            ].map((s,i)=> (
              <div key={i}>
                <div className="font-display-heavy" style={{fontSize:'clamp(30px,3vw,48px)', lineHeight:1, letterSpacing:'-0.04em'}}>{s.k}</div>
                <div style={{fontSize:11.5, color:'var(--text-3)', letterSpacing:'0.06em', textTransform:'uppercase', marginTop:8, whiteSpace:'pre-line', lineHeight:1.4}}>{s.l}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{zIndex:2, position:'relative', display:'flex', alignItems:'center', justifyContent:'space-between', fontSize:11.5, color:'var(--text-4)'}}>
          <span>© Impact Hub Madrid · 2026</span>
          <span style={{display:'flex', alignItems:'center', gap:14}}>
            <span>LCSP</span><span>·</span><span>RGPD</span><span>·</span><span>PLACE</span>
          </span>
        </div>
      </div>

      {/* Form pane */}
      <div className="login-form-pane">
        <div style={{maxWidth:420, width:'100%', margin:'0 auto'}}>
          <div className="login-mini-brand"><LizziLogo size={30}/></div>
          <div className="page-eyebrow" style={{marginBottom:18}}>BIENVENIDO DE VUELTA</div>
          <h2 className="font-display-heavy" style={{fontSize:'clamp(30px,3.2vw,42px)', margin:'0 0 12px 0', letterSpacing:'-0.035em', lineHeight:1}}>Inicia sesión</h2>
          <p style={{color:'var(--text-3)', fontSize:14.5, marginBottom:32, lineHeight:1.5}}>Accede con tu cuenta corporativa de Impact Hub. Las cuentas las crea el equipo de administración.</p>

          <form onSubmit={onSubmit} style={{display:'flex', flexDirection:'column', gap:14}}>
            <Field label="Correo corporativo" type="email" value={email} onChange={setEmail} placeholder="nombre@impacthub.net" icon="Mail"/>
            <Field label="Contraseña" type="password" value={password} onChange={setPassword} placeholder="Tu contraseña" icon="Shield"/>

            {error && (
              <div style={{fontSize:12.5, color:'var(--sem-danger)', background:'var(--bg-2)', border:'1px solid var(--line-2)', borderRadius:8, padding:'10px 12px'}}>
                {error}
              </div>
            )}

            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center', fontSize:12.5, marginTop:2}}>
              <span style={{color:'var(--text-4)', fontSize:11.5}}>Acceso restringido · solo personal autorizado</span>
              <button type="button" className="btn btn-ghost" style={{fontSize:12.5, padding:'4px 6px'}} onClick={()=>setForgot(true)}>¿Has olvidado tu contraseña?</button>
            </div>

            <button type="submit" className="btn btn-primary" style={{padding:'14px 18px', fontSize:14.5, justifyContent:'center', width:'100%', borderRadius:12, fontWeight:500, marginTop:4}} disabled={loading}>
              {loading
                ? (<><span className="skeleton" style={{width:14, height:14, borderRadius:999}}></span> Iniciando sesión…</>)
                : (<><Icon.Shield size={16}/> Iniciar sesión</>)
              }
            </button>
          </form>

          <div style={{display:'flex', alignItems:'center', gap:14, margin:'28px 0', color:'var(--text-4)', fontSize:11, letterSpacing:'0.08em'}}>
            <div style={{flex:1, height:1, background:'var(--line-1)'}}></div>
            <span style={{textTransform:'uppercase'}}>O explora sin cuenta</span>
            <div style={{flex:1, height:1, background:'var(--line-1)'}}></div>
          </div>

          <button className="btn btn-outline" style={{padding:'12px 18px', fontSize:14, justifyContent:'center', width:'100%', borderRadius:12}} onClick={enterDemo} disabled={demoLoading}>
            {demoLoading
              ? (<><span className="skeleton" style={{width:14, height:14, borderRadius:999}}></span> Cargando demo…</>)
              : (<><Icon.Sparkles size={15}/> Entrar como invitado · modo demo</>)
            }
          </button>
          <div style={{fontSize:11.5, color:'var(--text-4)', textAlign:'center', marginTop:10, lineHeight:1.5}}>
            Datos de ejemplo cargados en cliente · sin conexión a la base de datos
          </div>
        </div>
      </div>

      {forgot && <ForgotPasswordModal onClose={()=>setForgot(false)} />}
    </div>
  );
}

// Recuperación de contraseña.
// Seguridad: la respuesta es siempre la misma exista o no la cuenta (no
// permite enumerar correos), hay un enfriamiento entre envíos y el enlace
// solo puede volver a /reset-password de este mismo origen.
const RESET_COOLDOWN_SEC = 60;
const RESET_COOLDOWN_KEY = 'lizzi:reset-requested-at';

function ForgotPasswordModal({ onClose }) {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const send = async () => {
    if (loading) return;
    const normalized = email.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)) { setError('Introduce un correo válido.'); return; }
    let last = 0;
    try { last = Number(sessionStorage.getItem(RESET_COOLDOWN_KEY)) || 0; } catch (e) {}
    const wait = Math.ceil(RESET_COOLDOWN_SEC - (Date.now() - last) / 1000);
    if (wait > 0) { setError(`Espera ${wait} s antes de solicitar otro enlace.`); return; }
    setLoading(true);
    setError('');
    const { error: err } = await supabase.auth.resetPasswordForEmail(normalized, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    setLoading(false);
    if (err && (err.status === 429 || err.code === 'over_email_send_rate_limit' || err.code === 'over_request_rate_limit')) {
      setError('Se han solicitado demasiados enlaces. Espera unos minutos y vuelve a intentarlo.');
      return;
    }
    // Cualquier otro resultado se trata igual para no revelar si la cuenta existe.
    try { sessionStorage.setItem(RESET_COOLDOWN_KEY, String(Date.now())); } catch (e) {}
    setEmail(normalized);
    setSent(true);
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{width:460, padding:32}} onClick={e=>e.stopPropagation()}>
        <h3 className="font-display-heavy" style={{fontSize:28, margin:'0 0 10px 0', letterSpacing:'-0.03em'}}>Recuperar contraseña</h3>
        {sent ? (
          <p style={{fontSize:13.5, color:'var(--text-2)', marginBottom:24, lineHeight:1.5}}>
            Si existe una cuenta para <strong>{email}</strong>, recibirás un enlace de un solo uso para restablecer tu contraseña. Caduca en 1 hora y solo es válido el último que solicites. Si no lo ves, revisa la carpeta de spam.
          </p>
        ) : (
          <>
            <p style={{fontSize:13.5, color:'var(--text-3)', marginBottom:24, lineHeight:1.5}}>
              Introduce tu correo corporativo y te enviaremos un enlace seguro para fijar una nueva contraseña.
            </p>
            <Field label="Tu correo" type="email" value={email} onChange={setEmail} placeholder="nombre@impacthub.net" icon="Mail"/>
            {error && <div style={{fontSize:12.5, color:'var(--sem-danger)', marginTop:10}}>{error}</div>}
          </>
        )}
        <div style={{display:'flex',gap:8, justifyContent:'flex-end', marginTop:24}}>
          <button className="btn btn-ghost" onClick={onClose}>{sent ? 'Cerrar' : 'Cancelar'}</button>
          {!sent && <button className="btn btn-primary" onClick={send} disabled={loading}>{loading ? 'Enviando…' : 'Enviar enlace'}</button>}
        </div>
      </div>
    </div>
  );
}

function Field({ label, type, value, onChange, placeholder, icon, defaultValue }) {
  const Ico = icon ? Icon[icon] : null;
  const [focus, setFocus] = useState(false);
  const [show, setShow] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (show ? 'text' : 'password') : type;
  const EyeIco = show ? Icon.EyeOff : Icon.Eye;
  return (
    <label style={{display:'flex', flexDirection:'column', gap:8}}>
      <span style={{fontSize:11.5, color:'var(--text-3)', letterSpacing:'0.08em', textTransform:'uppercase', fontWeight:500}}>{label}</span>
      <div style={{
        display:'flex', alignItems:'center', gap:10, padding:'12px 14px',
        border:`1px solid ${focus ? 'var(--primary)' : 'var(--line-2)'}`,
        background:'var(--bg-1)', borderRadius:10, transition:'border 140ms',
        boxShadow: focus ? '0 0 0 3px var(--primary-soft)' : 'none',
      }}>
        {Ico && <span style={{color: focus ? 'var(--primary)' : 'var(--text-3)', transition:'color 140ms'}}><Ico size={15}/></span>}
        <input
          type={inputType}
          value={value}
          defaultValue={defaultValue}
          placeholder={placeholder}
          onChange={onChange ? (e)=>onChange(e.target.value) : undefined}
          onFocus={()=>setFocus(true)} onBlur={()=>setFocus(false)}
          style={{flex:1, background:'transparent', border:0, fontSize:14.5, color:'var(--text-1)'}}/>
        {isPassword && (
          <button type="button" onClick={()=>setShow(s=>!s)}
            aria-label={show ? 'Ocultar contraseña' : 'Mostrar contraseña'}
            style={{display:'flex', alignItems:'center', background:'transparent', border:0, cursor:'pointer', color:'var(--text-3)', padding:0}}>
            <EyeIco size={15}/>
          </button>
        )}
      </div>
    </label>
  );
}

window.LoginScreen = LoginScreen;

export { LoginScreen, Field };
